<template>
  <nav>
    <div class="left">
      <img class="favicon" src="@/../src/assets/portico-favicon.png" />
      <img class="logo" src="@/../src/assets/logo.png" />
    </div>
    <div class="right">
      {{ organization.organization_name }}
      <span class="sidebar-trigger" @click="sidebar">•••</span>
    </div>
  </nav>
</template>

<script>

import utils from '@/js/utils.js';
const { api_path } = utils;

const path = api_path.test.replace("api/v1", "");

import EventBus from "@/js/event-bus.js";

export default {
  name: "Nav",
  data () {
    return {
    };
  },

  methods: {
    sidebar: () => EventBus.$emit("toggleSidebar"),
  },
  props: ["organization"],
};
</script>

<style scoped>
nav {
  padding: 20px;
}

.group {
  margin-bottom: 30px;
}

.favicon {
  height: 30px;
}

.logo {
  height: 20px;
  vertical-align: top;
  margin-top: 5px;
}

.left {
  display: inline-block;
}

.right {
  float: right;
  margin-top: 5px;
}

.sidebar-trigger {
  display: none;
}

@media (max-width: 1500px) {
  .sidebar-trigger {
    display: inline;
    font-weight: 600;
    font-size: 1.5em;
    position: relative;
    top: 2px;
    margin-left: 10px;
    line-height: 0;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/generics/Nav.vue